import router from '@/router'

export default {
  state: {
    isCollapse: false,
    menu: [],
    menuTodo: {},
    currentMenu: null
  },
  getters: {},
  mutations: {
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse
    },
    setMenuTodo(state, val) {
      state.menuTodo = val
    },
    setMenu(state, val) {
      state.menu = val.data
      const temp = []
      state.menu.forEach(item => {
        if (item.companyCode === localStorage.getItem('companyCode')) {
          temp.push(item)
        }
      })
      const strMenu = JSON.stringify(temp)
      localStorage.setItem('menu', strMenu)
    },
    clearMenu(state) {
      state.menu = []
      localStorage.removeItem('menu')
    },
    addMenu(state) {
      // 查看是否
      if (!localStorage.getItem('menu')) {
        return
      }
      const menu = JSON.parse(localStorage.getItem('menu'))
      state.menu = menu
      const currentMenu = [
        {
          path: '/avplanPmp',
          component: () => import(`../views/Main`),
          children: []
        }
      ]
      //添加菜单
      // currentMenu[0].children = filterAsyncRouter(menu)


      menu.forEach(item => {
        if (item.path || (item.children && item.children.length > 0)) {
          if (item.children && item.children.length > 0) {
            item.children = item.children.map(item => {
              item.component = () => import(`../views/${item.url}`)
              // item.name = item.path
              // item.meta = {
              //   requireAuth: true,
              //   title: item.menuName
              // }
              if (item.meta.btnPermissions) {
                localStorage.setItem(item.menuName, JSON.stringify(item.meta.btnPermissions))
                localStorage.setItem(item.path, JSON.stringify(item.meta.btnPermissions))

              }
              return item
            })
            currentMenu[0].children.push(...item.children)
          } else {
            item.component = () => import(`../views/${item.url}`)
            // item.name = item.path
            // item.meta = {
            //   requireAuth: true,
            //   title: item.menuName
            // }
            if (item.meta.btnPermissions) {
              localStorage.setItem(item.menuName, JSON.stringify(item.meta.btnPermissions))
              localStorage.setItem(item.path, JSON.stringify(item.meta.btnPermissions))
            }
            currentMenu[0].children.push(item)
          }
        }
      })
      router.addRoutes(currentMenu)
    }


  },
  actions: {}
}

export const filterAsyncRouter = (menu) => { // 遍历后台传来的路由字符串，转换为组件对象
  return menu.filter(item => {
    if (item.path) {
      item.component = () => import(`../views/${item.url}`)
    }
    if (item.children && item.children.length) {
      item.children = filterAsyncRouter(item.children)
    }
    return true
  })
}



